import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { CustomFieldPlainText } from "~/components/CustomFields/CustomFieldInput/CustomFieldPlainText";
import { useUpdatePublicItemsCustomFieldValue } from "~/utils/CustomFields/useUpdatePublicItemsCustomFieldValue";
export const PublicBoardCustomFieldPlainText = /*#__PURE__*/ memo((param)=>{
    let { field, trackingLocation, canEditCustomFields, boardId, ...rest } = param;
    const { updatePublicItemsCustomFieldValue } = useUpdatePublicItemsCustomFieldValue();
    const updateCustomFieldValue = useCallback(async (value)=>{
        await updatePublicItemsCustomFieldValue({
            boardIds: [
                boardId
            ],
            baseCustomField: field,
            nextPlainTextValue: value,
            trackingLocation
        });
    }, [
        boardId,
        updatePublicItemsCustomFieldValue,
        field,
        trackingLocation
    ]);
    return /*#__PURE__*/ _jsx(CustomFieldPlainText, {
        ...rest,
        onSubmit: canEditCustomFields ? updateCustomFieldValue : undefined,
        field: field
    });
});
PublicBoardCustomFieldPlainText.displayName = "PublicBoardCustomFieldPlainText";
